/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CatalogUploadUrlResponseDto } from '../../models/catalog-upload-url-response-dto';
import { CreateCatalogUploadUrlDto } from '../../models/create-catalog-upload-url-dto';

export interface StoreCatalogsControllerCreateUploadUrl$Params {
  storeId: string;

  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
  body: CreateCatalogUploadUrlDto;
}

export function storeCatalogsControllerCreateUploadUrl(
  http: HttpClient,
  rootUrl: string,
  params: StoreCatalogsControllerCreateUploadUrl$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<CatalogUploadUrlResponseDto>> {
  const rb = new RequestBuilder(rootUrl, storeCatalogsControllerCreateUploadUrl.PATH, 'post');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CatalogUploadUrlResponseDto>;
    })
  );
}

storeCatalogsControllerCreateUploadUrl.PATH = '/api/v1/stores/{storeId}/catalogs/upload-url';
